import { useEffect, useState } from 'react';

import { ChainId, useEthers } from '@usedapp/core';

import { useTrackedState } from '@context/store';

export const useValidNetwork = () => {
  const { account, chainId } = useEthers();
  const { provider } = useTrackedState();
  const [invalidNetwork, setInvalidNetwork] = useState<boolean>();

  useEffect(() => {
    const correctChains =
      provider === 'bitcoincom_eth'
        ? [ChainId.Mainnet, ChainId.Polygon]
        : [ChainId.Sepolia];

    const invalidChain =
      account && (!correctChains.includes(chainId as ChainId) || !chainId);

    if (invalidChain) {
      setInvalidNetwork(true);
      return;
    }
    setInvalidNetwork(false);
  }, [account, provider, chainId]);

  return invalidNetwork;
};
